import { TRUSTED_LINK_ACCOUNTS } from './trustedAccounts'

export const hasClickableLinks = (username?: string): boolean =>
    !!username && TRUSTED_LINK_ACCOUNTS.has(username.toLowerCase())
